module.exports = __webpack_public_path__ + "static/media/login-bg.4f760242.jpg";